import  { useEffect, useState } from "react";
import "./EighthReport.css";

const QTag = ({ q, a, impacts }) => (
  <div style={{display:'flex',flexWrap:'wrap',gap:'5px 10px',alignItems:'center',background:'#f0f4ff',border:'1px solid #c7d7fa',borderRadius:'6px',padding:'7px 12px',marginBottom:'12px',fontSize:'12px',lineHeight:1.5}}>
    <span style={{background:'#3b5bdb',color:'#fff',fontWeight:700,padding:'2px 8px',borderRadius:4,fontSize:'10px',whiteSpace:'nowrap'}}>📋 FORM QUESTION</span>
    <span style={{color:'#1e3a8a',fontStyle:'italic'}}>"{q}"</span>
    <span style={{color:'#6b7280',fontSize:'11px'}}>→</span>
    <span style={{color:'#047857',fontWeight:700}}>You answered: <strong>{a}</strong></span>
    <span style={{color:'#6b7280',fontSize:'11px'}}>→</span>
    <span style={{color:'#7c3aed',fontSize:'11px'}}>📊 Impacts: {impacts}</span>
  </div>
);

const EighthReport = ({ res }) => {
  const [costStructureValue, setCostStructureValue] = useState("");
  const [revenueStreamsValue, setRevenueStreamsValue] = useState("");
  const [northStarMetricValue, setNorthStarMetricValue] = useState("");

  useEffect(() => {
    if (res.costStructure) setCostStructureValue(res.costStructure.trim());
    if (res.revenueStreams) setRevenueStreamsValue(res.revenueStreams.trim());
    if (res.northStarMetric) setNorthStarMetricValue(res.northStarMetric.trim());
  }, [res]);

  // ❗ Helper for case-insensitive match
  const normalize = (value = "") => value.trim().toLowerCase();

  // 7A Revenue Streams
  const revenueData = {
    subscription: {
      insights: ["High predictability", "Strong retention", "Easy to scale"],
    },
    fees: {
      insights: ["Good unit economics", "Scales with volume"],
    },
    ads: {
      insights: [
        "Useful for free, high-traffic apps",
        "Weak for early-stage B2B or niche tech",
      ],
    },
  };

  const selectedRevenueRow =
    revenueData[normalize(revenueStreamsValue)] || null;

  // 7B Cost Structure
  const costData = {
    team: {
      category: "Team Costs",
      structure: "Lean, cross-functional, specialized talent",
      reason: "Low overhead, agile, scalable team",
    },
    infra: {
      category: "Infrastructure",
      structure: "Cloud-based, scalable, pay-as-you-go",
      reason: "Flexible, low initial investment, scalable without high CAPEX",
    },
    marketing: {
      category: "Marketing Costs",
      structure: "Performance-driven, data-optimized, organic focus",
      reason: "Maximize ROI, sustainable growth, low CAC",
    },
  };

  const selectedRow = costData[normalize(costStructureValue)] || null;

  // 7C North Star Metric
  const northStarData = {
    "active users": {
      summary:
        "Indicates early traction and user demand, but investors value it only when engagement and conversions grow consistently.",
    },
    gmv: {
      summary:
        "Shows strong market activity and transaction scale, but investors focus on take-rate, margins, and whether GMV converts into real revenue.",
    },
    retention: {
      summary:
        "The most powerful indicator of product-market fit — proves users find lasting value, stay engaged, and generate long-term revenue.",
    },
  };

  const selectedNorthStarRow =
    northStarData[normalize(northStarMetricValue)] || null;

  return (
    <div style={{ padding: "22px" }}>
      <div className="eighth-module-container">
        <h3 className="module8-title"> <span className="module-prefix">Module 7:</span>  Revenue & Cost Simulation</h3>
        <QTag
          q="What is your primary revenue model, main cost driver, and the single key metric that defines your startup's growth?"
          a={`Revenue model: ${revenueStreamsValue || "—"} · Cost driver: ${costStructureValue || "—"} · North Star metric: ${northStarMetricValue || "—"}`}
          impacts="Revenue model investor attractiveness, unit economics efficiency, growth metric credibility, LTV/CAC benchmark"
        />
        <span className="corner top-left"></span>
        <span className="corner top-right"></span>
        <span className="corner bottom-left"></span>
        <span className="corner bottom-right"></span>

        {/* 7A Revenue Streams */}
        {selectedRevenueRow && (
          <table className="eighth-module-table">
            <thead>
              <tr>
                <td className="serial-cell">S.No</td>
                <th>Revenue Model</th>
                <th>Investor Insights</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="serial-cell">7 A</td>
                <td>{revenueStreamsValue}</td>
                <td>
                  {selectedRevenueRow.insights.map((point, index) => (
                    <div key={index}>• {point}</div>
                  ))}
                </td>
              </tr>
            </tbody>
          </table>
        )}

        {/* 7B – Cost Structure */}
        {selectedRow ? (
          <table className="eighth-module-table">
            <thead>
              <tr>
                <td className="serial-cell">S.No</td>
                <th>Cost Category</th>
                <th>Ideal Structure for Investors</th>
                <th>Reason</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="serial-cell">7 B</td>
                <td>{selectedRow.category}</td>
                <td>{selectedRow.structure}</td>
                <td>{selectedRow.reason}</td>
              </tr>
            </tbody>
          </table>
        ) : (
          <p>No data available. Please select Cost Structure.</p>
        )}

        {/* 7C – North Star Metric */}
        {selectedNorthStarRow && (
          <table className="eighth-module-table">
            <tbody>
              <tr>
                <td className="serial-cell">7 C</td>
                <td>{northStarMetricValue}</td>
                <td>{selectedNorthStarRow.summary}</td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default EighthReport;
